import moment from 'moment-timezone';
import {FIELD_DATE_PICKER, FIELD_SINGLE_CHECKBOX} from "../../../../constants/custom-field-types";

export default {
    computed: {
        hasPhoneField() {
            return this.campaign && this.campaign.fields && this.campaign.fields.includes('phone_number');
        },
        hasOptionalFields() {
            return this.hasGenderField || this.campaign && this.campaign.fields && this.campaign.fields.some(field => !['phone_number', 'gender'].includes(field));
        },
        hasGenderField() {
            return this.campaign && this.campaign.fields && this.campaign.fields.includes('gender');
        },
    },
    methods: {
        getFormattedFieldValue(field) {
            if (field.type === FIELD_DATE_PICKER && field.value !== null) {
                return moment(field.value).format('MMM D, YYYY');
            }

            if (field.type === FIELD_SINGLE_CHECKBOX) {
                return !!field.value ? 'yes' : 'no';
            }

            return field.value;
        }
    },
}